import { Dropdown } from '../../Components/Dropdown';
import { SearchField } from '../../Components/SearchField/SearchField';
import { Placement, Size } from '../../Components/designConstants';
import { SORT_OPTIONS, SortBy } from './copyTigerUtils';

interface SearchSortBarProps {
  searchId: string;
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchAriaLabel: string;
  sortValue: SortBy;
  onSortChange: (value: SortBy) => void;
}

export const SearchSortBar = ({
  searchId,
  searchValue,
  onSearchChange,
  searchAriaLabel,
  sortValue,
  onSortChange
}: SearchSortBarProps) => (
  <div className='copytiger-sidebar-search-sort'>
    <SearchField
      size={Size.LG}
      id={searchId}
      placeholder='Search'
      value={searchValue}
      onChange={e => onSearchChange(e.target.value)}
      aria-label={searchAriaLabel}
    />
    <div className='copytiger-sort-container'>
      <Dropdown
        overlayPlacement={Placement.RIGHT}
        value={sortValue}
        options={SORT_OPTIONS}
        onChange={onSortChange}
        size={Size.SM}
        label='Sort by'
      />
    </div>
  </div>
);
